import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { editPassportClick } from './actions';
import MaskedInput from 'react-maskedinput';
import {translate} from "react-i18next";

@translate(['modal'], {wait:true})
class PassportTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      seria: this.props.passport.seria || '',
      number: this.props.passport.number || '',
      issueDate: this.props.passport.issueDate || '',
      emitent: this.props.passport.emitent || '',
    };
  }

  render() {
    const {t} = this.props;


    return (
      <div id="account__tab-passport" className="popup__tab active">
        <form className="popupForm grayPopupForm popupForm-short" action="#">
          <div className="popup__settings-row">
            <div className="popup__settings__title popup__settings__title-long">{t('modal:passport__header')}</div>
            <div className="popup__settings__holder">
              <div className="row colRow">
                <div className="col col-3">
                  <label className="popupForm__label">{t('modal:passport__series')}</label>
                  <div className="wrap">
                    <MaskedInput
                      maxLength="5"
                      className="inputText size14"
                      type="text"
                      value={this.state.seria}
                      onChange={(e) => {
                        this.setState({
                          seria: e.target.value,
                        });
                      }}
                      mask="11 11" />
                  </div>
                </div>
                <div className="col col-9">
                  <label className="popupForm__label">{t('modal:passport__number')}</label>
                  <div className="wrap">
                    <MaskedInput
                      maxLength="6"
                      className="inputText size14"
                      type="text"
                      value={this.state.number}
                      onChange={(e) => {
                        this.setState({
                          number: e.target.value,
                        });
                      }}
                      mask="111111" />
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:passport__issue-date')}</label>
                <div className="wrap">
                  <MaskedInput
                      maxLength="10"
                      className="inputText size14"
                      type="text"
                      value={this.state.issueDate}
                      onChange={(e) => {
                        this.setState({
                          issueDate: e.target.value,
                        });
                      }}
                      mask="11.11.1111" />
                </div>
              </div>
              <div className="row">
                <label className="popupForm__label">{t('modal:passport__emitent')}</label>
                <div className="wrap">
                  <input
                    className="inputText size14"
                    type="text"
                    defaultValue={this.state.emitent}
                    onChange={(e) => {
                      this.setState({
                        emitent: e.target.value,
                      });
                    }} />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <button
              type="button"
              className="btn"
              onClick={() => this.props.handleSaveClick(this.state)}
            >{t('modal:passport__save')}</button>
          </div>
        </form>
      </div>
    );
  }
}

PassportTab.propTypes = {
  passport: PropTypes.object,
  handleSaveClick: PropTypes.func,
};

export default connect(
  (state) => {
    return {
      passport: state.settings.passport,
    };
  },
  (dispatch) => {
    return {
      handleSaveClick(passport) {
        return dispatch(editPassportClick({passport}));
      },
    };
  }
)(PassportTab);



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/ProfileSettings/PassportTab.js